import { render, staticRenderFns } from "./IncRnaDifferentialExpression.vue?vue&type=template&id=b8bbec94&scoped=true"
import script from "./IncRnaDifferentialExpression.vue?vue&type=script&lang=js"
export * from "./IncRnaDifferentialExpression.vue?vue&type=script&lang=js"
import style0 from "./IncRnaDifferentialExpression.vue?vue&type=style&index=0&id=b8bbec94&prod&scoped=true&lang=css"
import style1 from "./IncRnaDifferentialExpression.vue?vue&type=style&index=1&id=b8bbec94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bbec94",
  null
  
)

export default component.exports